const A = `${process.env.PUBLIC_URL}/assets`;

export const SITE = {
  brand: "Lovely Foodpacks",
  productBrand: "Lovely Leafs",
  parent: "JJJ Industries",
  md: "D. Jebastin",
  mdTitle: "Managing Director, JJJ Industries",
  mdDegrees: "B.Tech., M.E., M.B.A.",
  tagline: "Traditional Service in Economy way",
  since: 2000,
  whatsappSales: "917200505506",
  whatsappDisplay: "+91 72005 05506",
  officeDisplay: "04562 275519",
  directorDisplay: "+91 94422 23442",
  email: "mailbox@lovelyleafs.in",
  indiamart: "https://www.indiamart.com/jjjindustries-sivakasi/",
  hoAddress: "103-F Arumugam Road, Lovely Leafs Building, 1st Floor, Sivakasi — 626123, Tamil Nadu, India",
  factoryAddress: "Anaiyur, Sivakasi, Tamil Nadu, India",
  mapEmbed:
    "https://maps.google.com/maps?q=Lovely%20Leafs%2C%20Arumugam%20Road%2C%20Sivakasi%20626123%2C%20Tamil%20Nadu&t=&z=15&ie=UTF8&iwloc=&output=embed",
};

export const IMAGES = {
  logo: `${A}/logo.png`,
  leaf: `${A}/leaf-illustration.jpg`,
  heroPack: `${A}/p-banana-leaf-pack.jpg`,
};

export const MARQUEE_ITEMS = [
  "Since 2000",
  "Paper Banana Leaf",
  "Exporting Globally",
  "Eco-Friendly",
  "CFTRI Tested",
  "100% Recyclable",
  "Sivakasi, India",
];

export const PRODUCTS = [
  {
    id: "paper-banana-leaf",
    name: "Paper Banana Leaf",
    tag: "Flagship",
    desc: "The traditional South Indian banana-leaf dining experience, re-engineered in food-grade paper. Ample space to hold a full meals service — hygienic, disposable, economical.",
    points: ["100 pcs per pack", "Food-grade & damp proof", "Meals & Tiffin sizes"],
    img: `${A}/leaf-meal-square.jpg`,
    span: "md:col-span-7 md:row-span-2",
    seo: "Paper banana leaf manufacturer Sivakasi — disposable banana leaf sheets for hotels, catering & export.",
    alsoKnownAs: ["Kela Patta", "Plastic Banana Leaf", "Disposable Banana Leaf", "Lovely Leaf", "Lovely Paper Banana Leaf", "Star Leaf", "Star Paper Banana Leaf", "Paper Banana Leaf Manufacturer", "Paper Banana Leaf Sivakasi"],
    specs: [
      ["Sizes", "Meals Leaf · Tiffin Leaf"],
      ["Material", "Food-grade paper with leaf-green print, damp-proof coated"],
      ["Thickness", "80 – 120 GSM options"],
      ["Packing", "100 sheets per packet · strapped master bundles for wholesale"],
      ["Shelf Life", "24+ months, dry storage — no wilting unlike natural leaf"],
      ["Customization", "Brand / hotel name printing available"],
      ["Applications", "Meals service, weddings, temples, catering, parcel lining"],
    ],
    gallery: [`${A}/leaf-meal-square.jpg`, `${A}/leaf-meal-wide.jpg`, `${A}/leaf-pack-single.jpg`, `${A}/leaf-pack-pile.jpg`, `${A}/p-banana-leaf.jpg`, `${A}/p-banana-leaf-pack.jpg`],
  },
  {
    id: "food-wrapping-paper",
    name: "Food Wrapping Paper",
    tag: "HoReCa Essential",
    desc: "Ideal wrapper for parathas, chapattis, fried rice and much more — keeps food warm, fresh and presentable.",
    points: ["Grease resistant", "Heat friendly"],
    img: `${A}/p-wrapper.jpg`,
    span: "md:col-span-5",
    seo: "Food wrapping paper manufacturer India — grease-resistant wraps for parathas, chapatis & fried rice.",
    specs: [
      ["Sizes", "Standard sheet sizes & roll form (custom cutting on order)"],
      ["Material", "Food-grade kraft / white paper"],
      ["Thickness", "40 – 60 GSM"],
      ["Finish", "Grease-resistant, heat friendly"],
      ["Packing", "Ream-packed, wholesale bundles"],
      ["Customization", "Printed branding available on bulk orders"],
      ["Applications", "Parathas, chapattis, fried rice, bakery & snack wrapping"],
    ],
    gallery: [`${A}/p-wrapper.jpg`, `${A}/p-wrapper-banner.jpg`],
  },
  {
    id: "aluminium-foil-paper",
    name: "Aluminium Foil Paper",
    tag: "Kertas Foil",
    desc: "Thin, flexible food-grade aluminium laminated on paper back — excellent heat resistance, tear resistant, superior leak proof. Ideal for oily foods.",
    points: ["Sizes 10×10 · 12×12 · 14×14", "70–130 GSM", "Heat & leak proof"],
    img: `${A}/foil-advantages.jpg`,
    span: "md:col-span-5",
    seo: "Aluminium foil paper (kertas foil) — heat & leak proof foil sheets for oily foods, sizes 10x10, 12x12, 14x14.",
    alsoKnownAs: ["Food Wrapping Foil Paper", "Kertas Foil", "Silver Foil Paper", "Foil Paper Manufacturer India"],
    specs: [
      ["Sizes", "10 × 10 · 12 × 12 · 14 × 14 inch"],
      ["Material", "Food-grade aluminium laminated on paper back"],
      ["Thickness", "70 – 130 GSM"],
      ["Properties", "Excellent heat resistance · tear resistant · superior leak proof"],
      ["Best For", "Oily & gravy foods, biryani, fried items"],
      ["Packing", "Sheet-packed, wholesale cartons"],
      ["Customization", "Size conversion on bulk orders"],
      ["Applications", "Restaurants, caterers, sweet stalls, takeaway counters"],
    ],
    gallery: [`${A}/foil-advantages.jpg`, `${A}/p-foil.jpg`],
  },
  {
    id: "silver-parcel-paper",
    name: "Silver Parcel Paper",
    tag: "Wholesale Favourite",
    desc: "High-shine silver laminated parcel paper — the takeaway trade's everyday wrap. Dealer-friendly packing: strapped 10 packets of 100 sheets each.",
    points: ["10 packets per strap", "100 sheets per packet", "High-shine finish"],
    img: `${A}/silver-parcel-strap.jpg`,
    span: "md:col-span-3",
    seo: "Silver parcel paper manufacturer Sivakasi — aluminium foil paper sheets for parcel packing, wholesale strap packing.",
    alsoKnownAs: ["Aluminium Foil Paper", "Silver Paper", "Parcel Paper", "Silver Foil Wrapping Paper", "Silver Paper Manufacturer Sivakasi"],
    specs: [
      ["Sizes", "Standard parcel sheet sizes (A – D range)"],
      ["Material", "Silver foil laminated on food-grade paper"],
      ["Finish", "High-shine silver, grease & leakage resistant"],
      ["Packing", "100 sheets per packet · 10 packets per strap"],
      ["Customization", "Brand printing on bulk orders"],
      ["Applications", "Hotel & restaurant parcel packing, chapathi/paratha wrap, sweet stalls"],
    ],
    gallery: [`${A}/silver-parcel-strap.jpg`, `${A}/p-silver-parcel.jpg`],
  },
  {
    id: "paper-container-boxes",
    name: "Paper Container Boxes",
    tag: "Takeaway",
    desc: "Sturdy, stackable takeaway boxes built for cloud kitchens, caterers and restaurants — packed 4 boxes as a bundle for wholesale.",
    points: ["Wholesale bundles", "Custom printing"],
    img: `${A}/p-boxes.jpg`,
    span: "md:col-span-3",
    seo: "Paper container boxes wholesale — sturdy takeaway boxes for cloud kitchens, caterers & restaurants.",
    specs: [
      ["Capacities", "250 ml – 1000 ml range"],
      ["Material", "Food-grade paperboard, leak-resistant coating"],
      ["Form", "Stackable, lock-flap takeaway boxes"],
      ["Packing", "4 boxes per bundle (wholesale master packs)"],
      ["Customization", "Full-colour custom printing with your brand"],
      ["Applications", "Cloud kitchens, restaurants, catering, meal delivery"],
    ],
    gallery: [`${A}/p-boxes.jpg`],
  },
  {
    id: "paper-plates",
    name: "Paper Plates",
    tag: "Biodegradable",
    desc: "Biodegradable plates for hotels, weddings, temples and events — firm hold for full meals with an eco-clean conscience.",
    points: ["Compostable", "Event-ready bulk"],
    img: `${A}/p-hawker.jpg`,
    span: "md:col-span-3",
    seo: "Biodegradable paper plates manufacturer — compostable plates for hotels, weddings & events.",
    specs: [
      ["Sizes", "6 inch – 12 inch range"],
      ["Material", "Biodegradable & compostable paperboard"],
      ["Strength", "Firm hold for full meals — no sagging"],
      ["Packing", "Bulk shrink-packs for events & wholesale"],
      ["Certifications", "Food safety compliant, eco-friendly"],
      ["Applications", "Hotels, weddings, temples, functions, street food"],
    ],
    gallery: [`${A}/p-hawker.jpg`],
  },
  {
    id: "aluminium-container-lids",
    name: "Aluminium Container Closure Lids",
    tag: "Silver Lid Paper",
    desc: "Board-backed silver lids that seal aluminium containers tight — OTG adaptable, leakage proof, backside customizable with your brand.",
    points: ["Biodegradable board", "Brand customization"],
    img: `${A}/p-lids.jpg`,
    span: "md:col-span-3",
    seo: "Aluminium container closure lids (silver lid paper) — leakage proof, OTG adaptable, brand customizable.",
    specs: [
      ["Fits", "Standard aluminium container sizes (matching lid range)"],
      ["Material", "Silver foil laminated on biodegradable board"],
      ["Properties", "Leakage proof seal · OTG / oven adaptable"],
      ["Backside", "Customizable with your brand print"],
      ["Packing", "Sheet-packed wholesale cartons"],
      ["Applications", "Parcel biryani, gravies, sweets, ready-meal packing"],
    ],
    gallery: [`${A}/p-lids.jpg`],
  },
];

export const CHAPTERS = [
  {
    no: "01",
    year: "2000",
    title: "Rooted in Sivakasi",
    body: "In the year 2000 — in Sivakasi, India's historic hub of print and packaging — JJJ Industries began crafting a simple idea: the banana leaf, reimagined in paper. Under Managing Director D. Jebastin, Lovely Foodpacks gave hotels and caterers the tradition of leaf dining without the scarcity, storage and hygiene challenges of natural leaves.",
  },
  {
    no: "02",
    year: "The Craft",
    title: "Why Paper Banana Leaf",
    body: "For centuries, the banana leaf has been South Asia's original plate — natural, aromatic, auspicious. But natural leaves wilt, tear and demand cold-chain logistics. Our paper banana leaf preserves the experience — the colour, the expanse, the ceremony — while being food-safe, shelf-stable, printable and available every single day of the year.",
  },
  {
    no: "03",
    year: "26 Years",
    title: "Six States Strong",
    body: "Now stepping into our 26th year, Lovely Leafs commands a domestic presence across Tamil Nadu, Kerala, Karnataka, Maharashtra, Andhra Pradesh and Madhya Pradesh — trusted by dealers, distributors, wholesalers and the hotel & catering trade.",
  },
  {
    no: "04",
    year: "Global",
    title: "From Sivakasi to the World",
    body: "Our export lines serve importers across the UAE, Mauritius, Malaysia, Singapore and Papua New Guinea — carrying Indian eco-packaging to diaspora kitchens, hawker streets and hotel tables worldwide.",
  },
];

export const PROCESS_STEPS = [
  { no: "01", title: "Sourcing", body: "Food-grade paper & board sourced to specification — the foundation of a safe, consistent leaf." },
  { no: "02", title: "Printing", body: "Precision printing brings the signature leaf-green finish and custom branding to life." },
  { no: "03", title: "Lamination & Cutting", body: "Damp-proof lamination and die-cutting shape every sheet to exact size — from leaf to lid." },
  { no: "04", title: "Quality Check", body: "Every batch is inspected against CFTRI-tested, food-safety benchmarks before it leaves the line." },
  { no: "05", title: "Packing & Dispatch", body: "Counted, strapped and boxed — 100 sheets a packet, 4 boxes a bundle — shipped across India and the world." },
];

export const FACTORY_IMAGES = [
  { img: `${A}/f-stack.jpg`, caption: "Leaf packets, strapped & ready" },
  { img: `${A}/f-boxes.jpg`, caption: "Lovely Leafs box packing line" },
  { img: `${A}/f-export.jpg`, caption: "Export consignments — JJJ Industries" },
  { img: `${A}/leaf-pack-pile.jpg`, caption: "Retail packs, market ready" },
];

export const USE_CASES = [
  {
    title: "Hotel Industry",
    body: "From banana-leaf meals service to room-service parcel paper — hygienic, presentable, and economical at hotel scale.",
  },
  {
    title: "Catering Industry",
    body: "Weddings, temples and corporate events served on leaf, wrapped fresh, and sealed tight — thousands of covers a day.",
  },
  {
    title: "Food Packaging & Processing",
    body: "Boxes, lids, foil and wrappers engineered for cloud kitchens, sweet stalls, bakeries and food processors.",
  },
];

export const DOMESTIC_STATES = [
  "Tamil Nadu",
  "Kerala",
  "Karnataka",
  "Maharashtra",
  "Andhra Pradesh",
  "Madhya Pradesh",
];

export const EXPORT_MARKETS = ["UAE", "Mauritius", "Malaysia", "Singapore", "Papua New Guinea"];

export const CERTIFICATIONS = [
  { name: "CFTRI", sub: "Food Research Tested" },
  { name: "TÜV SÜD", sub: "International Quality" },
  { name: "Food Safety", sub: "Food-Grade Certified" },
  { name: "ECO", sub: "Eco-Friendly Products" },
  { name: "100% Recyclable", sub: "Sustainable by Design" },
];

export const BUYER_TYPES = ["Dealer", "Distributor", "Wholesaler", "Retailer", "End Customer", "International Importer"];

export const buildWhatsAppLink = (msg) =>
  `https://wa.me/${SITE.whatsappSales}?text=${encodeURIComponent(msg)}`;
